const markdown = `
##### *To use a barcode scanner in this application while using firefox, you need to disable the "/" shortcut key in the browser settings.*

#### Step 1

* Go to the *Advanced Prefences* menu in Firefox by opening a new tab and entering **about:config** in the address bar.

#### Step 2

* In the search bar, enter the following setting name: **accessibility.typeaheadfind.manual**

#### Step 3

* Toggle the setting to false with the button on the right.
* This should disable the "/" shortcut key and allow the scanner to work properly.
`;

const title = 'Disabling the "/" shortcut key in Firefox';
module.exports = 
{
    markdown,
    title
};